import { useEffect } from "react";
import { isAudioFullyBuffered } from "../utils/listeningPreload";

// Background downloads must yield to the actual player's network activity.
export const useAudioLoading = (audioRef, url, onAudioLoadingChange) => {
  useEffect(() => {
    if (!onAudioLoadingChange) return;
    const audio = audioRef.current;
    onAudioLoadingChange(!!url);
    if (!audio || !url) return;
    const loading = () => onAudioLoadingChange(true);
    const update = () => onAudioLoadingChange(!audio.ended && !isAudioFullyBuffered(audio));
    const readyEvents = ["progress", "canplay", "canplaythrough", "playing", "suspend", "ended"];
    const loadingEvents = ["loadstart", "waiting", "stalled", "error"];
    readyEvents.forEach(event => audio.addEventListener(event, update));
    loadingEvents.forEach(event => audio.addEventListener(event, loading));
    if (audio.getAttribute("src") === url) update();
    return () => {
      readyEvents.forEach(event => audio.removeEventListener(event, update));
      loadingEvents.forEach(event => audio.removeEventListener(event, loading));
    };
  }, [audioRef, url, onAudioLoadingChange]);
};
